export class APXNetworkError extends Error {
	response: Response;
	constructor(message: string, response: Response) {
		super(message);
		this.name = this.constructor.name;
		this.response = response;
		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, APXNetworkError);
		}
	}
}

export class APXUserNotLoggedInError extends Error {
	constructor() {
		super('User not logged in');
		// Maintains proper stack trace for where our error was thrown (only available on V8)
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, APXUserNotLoggedInError);
		}
	}
}
